import { staticText } from "../../../statics/static-text";

// TEXT
export const text = { ...staticText.tableColumns };

// STYLES

// DATA

// TYPES
export type Props = {
  content?: string | null;
  className?: string;
  disableTooltip?: boolean;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
